<template>
  <div class="container">
    <main class="sub-content">
      <div v-if="!isModal" class="tit"><RouteBack /> 정기 유지보수</div>
      <article class="sub">
        <section class="box-bg search-area">
          <div class="row row_jsa">
            <dl>
              <dt>등록일</dt>
              <dd>
                <DxDateBox
                  v-model="searchData.startDate"
                  :max="searchData.endDate"
                  display-format="yyyy-MM-dd"
                  styling-mode="outlined"
                  placeholder="from"
                />
              </dd>
              <dd>
                <DxDateBox
                  v-model="searchData.endDate"
                  :min="searchData.startDate"
                  display-format="yyyy-MM-dd"
                  styling-mode="outlined"
                  placeholder="to"
                />
              </dd>
            </dl>
          </div>
          <div class="taC">
            <a class="btn bg-default" @click="handleSearch(true)">조회</a>
            <a class="btn bg-default" @click="handleCreate()">등록</a>
          </div>
        </section>
      </article>
      <section>
        <div>
          <div class="tbl2">
            <table>
              <colgroup>
                <col style="width: 26%;" />
                <col style="width: 18%;" />
                <col style="width: 34%" />
                <col style="width: 28%;" />
                <col style="width: 28%;" />
              </colgroup>
              <thead>
                <tr>
                  <th>날짜</th>
                  <th>시간</th>
                  <th>ATM이름</th>
                  <th>특이사항</th>
                  <th>상세위치</th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="tbl2" style="height: calc(100vh - 210px); overflow: auto">
            <table>
              <colgroup>
                <col style="width: 26%;" />
                <col style="width: 18%;" />
                <col style="width: 34%" />
                <col style="width: 28%;" />
                <col style="width: 28%;" />
              </colgroup>
              <tbody>
                <tr v-for="(data, index) in dataList" :key="index">
                  <td>{{ data.regDay }}</td>
                  <td>{{ data.regTime }}</td>
                  <td
                    style="color:green"
                    @click="handleUpdate(data.atmMntcHstrNum)"
                  >
                    {{ data.atmNm }}
                  </td>
                  <td
                    :style="{ color: data.atmMntcPecuCtts ? 'green' : '' }"
                    @click="handleShowDrWt(data, 'atmMntcPecuCd')"
                  >
                    {{ data.atmMntcPecuCdNm }}
                  </td>
                  <td
                    :style="{ color: data.atmMntcDtlLocCtts ? 'green' : '' }"
                    @click="handleShowDrWt(data, 'atmMntcDtlLoc')"
                  >
                    {{ data.atmMntcDtlLocNm }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import DxDateBox from 'devextreme-vue/date-box'
import {formatMessage} from 'devextreme/localization'
import { IMG_SERVER_URL } from '../customerCare'

import AtmMntcHstrUpdate from './AtmMntcHstrUpdate.vue'
import AtmMntcHstrInsert from './AtmMntcHstrInsert.vue'
import RouteBack from '@/components/RouteBack.vue'

export default {
  name: 'AtmMntcHstr',
  components: {
    DxDateBox,
    RouteBack
  },
  props: [
    'isModal'
  ],
  data () {
    const vm = this
    return {
      jQuery,
      prefixUrl: '/api/purchase/customerCare',
      pagingData: {
        skip: 0,
        totalRowCount: 0,
        rowCount: 50
      },
      searchData: {
        // 화면이 열렸을때 검색조건 세팅하기
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
        stat: '',
        type: '',
        condition: '',
        conditionText: ''
      },
      dataList: [],
      cacheSearchData: null,
      cachePagingData: null,
      atmMntcPecuCdList: [],
      atmMntcDtlLocList: []
    }
  },
  watch: {
    '$route' (from, to) {
      this.handleSearch()
    }
  },
  computed: {
    userId () {
      return window.$store.getters['Login/getUserId']
    },
    imageUrl () {
      return IMG_SERVER_URL + this.mntcData.apndFlInfo
    }
  },
  methods: {
    formatMessage: formatMessage,
    async handleSearch (buttonClick) {
      if (buttonClick) {
        this.dataList = []
        this.pagingData.skip = 0
      }

      const params = {
        ...this.searchData,
        skip: this.pagingData.skip,
        take: this.pagingData.rowCount,
        condition: '2',
        conditionText: this.userId,
        mobile: 'mobile'
      }

      const {data} = await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrList', {params: params})

      if (data.result.list.length > 0) {
        this.dataList = []
        data.result.list.forEach(obj => {
          if (obj.atmMntcPecuCd) {
            const cmmnCdTempList = this.atmMntcPecuCdList.filter(cmcdObj => cmcdObj.cmnsCd === obj.atmMntcPecuCd)
            obj.atmMntcPecuCdNm = cmmnCdTempList.length > 0 ? cmmnCdTempList[0].cmnsCdNm : ''
          }
          if (obj.atmMntcDtlLoc) {
            const cmmnCdTempList = this.atmMntcDtlLocList.filter(cmcdObj => cmcdObj.cmnsCd === obj.atmMntcDtlLoc)
            obj.atmMntcDtlLocNm = cmmnCdTempList.length > 0 ? cmmnCdTempList[0].cmnsCdNm : ''
          }
          this.dataList.push(obj)
        })
        this.pagingData.skip = this.pagingData.skip + this.pagingData.rowCount
      }

      this.pagingData.skip = this.pagingData.skip + this.pagingData.rowCount
    },
    handleCreate () {
      window.$store.commit('ModalStore/addModal', { comp: AtmMntcHstrInsert, title: '유지보수 결과 수정', propData: { isModal: this.isModal } })
    },
    handleUpdate (atmMntcHstrNum) {
      window.$store.commit('ModalStore/addModal', { comp: AtmMntcHstrUpdate, title: '유지보수 결과 수정', propData: { atmMntcHstrNum } })
      // this.$modal.show('atmObstHstrListModal', { comp: AtmMntcHstrUpdate,  })
      // this.$router.push({name: 'AtmMntcHstrUpdate', params: { atmMntcHstrNum }})
    },
    formatDate (value) {
      if (value) {
        return moment(value).format('yyyy-MM-DD HH:mm:SS')
      } else {
        return ''
      }
    },
    async getCommCdList (cmnsCdGrpId) {
      const params = { cmnsCdGrpId }
      const res = await this.$http.get('/api/appmgmt/common/code/list', {params, data: {isLoadingHide: 'Y'}})

      if (res) {
        const { data: { result } } = res
        return result
      }
      return []
    },
    handleShowDrWt (data, flag) { // DR_WRT, 900
      let msg = ''
      let isShowModal = false
      if (flag === 'atmMntcPecuCd' && data.atmMntcPecuCtts) {
        msg = data.atmMntcPecuCdNm
        isShowModal = true
      } else if (flag === 'atmMntcDtlLoc' && data.atmMntcDtlLocCtts) {
        msg = data.atmMntcDtlLocCtts
        isShowModal = true
      }
      if (isShowModal) {
        this.$Alert.alert(msg)
      }
    }
  },
  async mounted () {
    this.atmMntcPecuCdList = await this.getCommCdList('ATM_MNTC_PECU_CD')
    this.atmMntcDtlLocList = await this.getCommCdList('ATM_MNTC_DTL_LOC')
    this.handleSearch()
    /*
    window.onscroll = () => {
      if ($(window).scrollTop() >= $(document).height() - $(window).height()) {
        this.handleSearch()
      }
    }
    */
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmMntcHstr.vue